var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pdfslider" }, [
    _c("div", { staticClass: "d-flex justify-content-flex-end" }, [
      _c(
        "div",
        { staticClass: "numbers w-100" },
        [
          _c(
            "b-link",
            {
              staticClass: "text-brand-dark",
              attrs: { disabled: _vm.slide === 1 },
              on: {
                click: function ($event) {
                  return _vm.slideBack("top arrow")
                },
              },
            },
            [
              _c("b-icon", {
                staticClass: "h5 m-0",
                attrs: { icon: "chevron-left" },
              }),
            ],
            1
          ),
          _vm._l(_vm.lastSlide, function (i) {
            return _c(
              "h5",
              {
                staticClass: "number text-brand-medium user-select-none m-0",
                class: i === _vm.slide ? "active text-brand-dark" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeSlide(i, "top number")
                  },
                },
              },
              [_vm._v(_vm._s(i))]
            )
          }),
          _c(
            "b-link",
            {
              staticClass: "text-brand-dark h5 m-0",
              attrs: { disabled: _vm.lastSlide === _vm.slide },
              on: {
                click: function ($event) {
                  return _vm.slideForward("top arrow")
                },
              },
            },
            [_c("b-icon", { attrs: { icon: "chevron-right" } })],
            1
          ),
        ],
        2
      ),
      _c("div", { staticClass: "mb-1 mb-lg-2" }, [_vm._t("default")], 2),
    ]),
    _c(
      "div",
      { staticClass: "pdfslide d-flex justify-content-center" },
      [
        _c(
          "b-link",
          {
            staticClass:
              "d-none d-lg-flex justify-content-center align-items-center",
            attrs: { disabled: _vm.slide === 1 },
            on: {
              click: function ($event) {
                return _vm.slideBack("side arrow")
              },
            },
          },
          [
            _c("b-icon", {
              staticClass: "h1",
              attrs: { icon: "chevron-left" },
            }),
          ],
          1
        ),
        _c("pdf-viewer", {
          attrs: {
            url: _vm.currentUrl,
            maxHeight: _vm.height,
            defaultWidth: _vm.width,
            showAll: false,
            disableHeader: true,
            emitPages: true,
            page: _vm.slide,
          },
          on: { setPage: _vm.setPage, setPagecount: _vm.setPagecount },
        }),
        _c(
          "b-link",
          {
            staticClass:
              "d-none d-lg-flex justify-content-center align-items-center",
            attrs: { disabled: _vm.lastSlide === _vm.slide },
            on: {
              click: function ($event) {
                return _vm.slideForward("side arrows")
              },
            },
          },
          [
            _c("b-icon", {
              staticClass: "h1",
              attrs: { icon: "chevron-right" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }